export function castArrayNonEmpty<T>(value: T | T[] | undefined): T[] {
  if (value === undefined) return [];
  return Array.isArray(value) ? value.filter((v): v is T => v !== undefined) : [value];
}

export function toNonEmptyArray<T>(input: string | T[] | undefined): T[] | undefined {
  if (input === undefined) return undefined;

  const arr = typeof input === 'string' ? [input as unknown as T] : castArrayNonEmpty(input);

  return arr.length > 0 ? arr : undefined;
}
